"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSAFE_ONESHOT_ENFORCED_OUTPUTS_MSG = void 0;
exports.isSafeOneshotNftEnforcedOutputs = isSafeOneshotNftEnforcedOutputs;
exports.assertSafeOneshotNftEnforcedOutputs = assertSafeOneshotNftEnforcedOutputs;
const ecash_lib_1 = require("ecash-lib");
/**
 * Error thrown when an ONESHOT offer has enforced outputs that would not
 * assign the offered token to the first taker-appended output.
 */
exports.UNSAFE_ONESHOT_ENFORCED_OUTPUTS_MSG = 'Refusing ONESHOT offer: enforcedOutputs must be exactly OP_RETURN SLP SEND [0, atoms] plus one maker payment so the token is assigned to the first taker output';
/**
 * Return true if ONESHOT enforced outputs match the safe NFT/sale shape used
 * by Agora marketplaces:
 *
 * - Exactly two enforced outputs (OP_RETURN + maker payment)
 * - OP_RETURN is an SLP SEND with amounts `[0, atoms]` and `atoms > 0`
 *
 * With that shape, `AgoraOffer.take()` appends the buyer's token/dust output
 * at index 2, which is where SLP assigns the non-zero amount. Extra enforced
 * outputs (or other SEND amount layouts) can redirect the token to a
 * maker-controlled output while the buyer still pays the ask.
 */
function isSafeOneshotNftEnforcedOutputs(enforcedOutputs) {
    if (enforcedOutputs.length !== 2) {
        return false;
    }
    const opreturn = enforcedOutputs[0];
    if (opreturn.sats !== 0n) {
        return false;
    }
    let parsed;
    try {
        parsed = (0, ecash_lib_1.parseSlp)(opreturn.script);
    }
    catch {
        return false;
    }
    if (parsed === undefined || parsed.txType !== ecash_lib_1.SEND_STR) {
        return false;
    }
    const { sendAtomsArray } = parsed;
    return (sendAtomsArray.length === 2 &&
        sendAtomsArray[0] === 0n &&
        sendAtomsArray[1] > 0n);
}
/**
 * Throw if ONESHOT enforced outputs are not the safe marketplace shape.
 */
function assertSafeOneshotNftEnforcedOutputs(enforcedOutputs) {
    if (!isSafeOneshotNftEnforcedOutputs(enforcedOutputs)) {
        throw new Error(exports.UNSAFE_ONESHOT_ENFORCED_OUTPUTS_MSG);
    }
}
//# sourceMappingURL=oneshotValidate.js.map